import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { compose } from "redux";
// i18next
import { withNamespaces } from "react-i18next";
// Ducks
import { clearSelectedCandidate } from "../../UsersList/UsersList.ducks";
import { navigateTo } from "../../Dashboard.ducks";
// i18n

class BookingsToolbar extends Component {
  clearSelectedCandidate = () => {
    const { clearSelectedCandidate } = this.props;

    clearSelectedCandidate();
  };

  handleNavigationButton = (event) => {
    event.stopPropagation();

    const { navigateTo, pathname } = this.props;

    const path = pathname.includes(`bookings`) ? `/dashboard/` : `/dashboard/bookings/`;

    return navigateTo(path);
  };

  render() {
    const { candidate, pathname, t, userRole, isUserActive } = this.props;

    const isBookingsScreen = pathname.includes(`bookings`);
    const isAdmin = userRole === `admin`;

    if (!isBookingsScreen && !isAdmin) {
      return null;
    }

    return (
      <div
        className="col-sm-12"
        style={{
          display: `flex`,
          alignItems: `center`,
          flexWrap: `wrap`,
          marginTop: 40
        }}
      >
        {candidate ? (
          <div
            style={{
              display: `flex`,
              alignItems: `flex-end`,
              flexWrap: `wrap`
            }}
          >
            <h2 style={{ margin: 0, marginRight: `0.5em` }}>
              {`${candidate.firstName} ${candidate.lastName} `}
              <small>{candidate.email}</small>
            </h2>

            <button
              className="btn  btn-primary "
              onClick={this.clearSelectedCandidate}
              type="button"
            >
              {t(`modules.localization.register.authenticated.bookings.changeCandidate`)}
            </button>
          </div>
        ) : (
          isBookingsScreen && (
            <h1 style={{ color: `rgb(50, 118, 177)` }}>
              {t(`modules.localization.register.authenticated.bookings.myBookings`)}
            </h1>
          )
        )}
        <button
          className="btn  btn-primary"
          disabled={!isAdmin && !isUserActive}
          onClick={this.handleNavigationButton}
          style={{ marginLeft: `auto` }}
          type="button"
        >
          {isBookingsScreen
            ? t(`modules.localization.register.authenticated.bookings.bookNow`)
            : t(`modules.localization.register.authenticated.bookings.myBookings`, {
                context: `admin`
              })}
        </button>
      </div>
    );
  }
}

BookingsToolbar.propTypes = {
  candidate: PropTypes.object,
  clearSelectedCandidate: PropTypes.func.isRequired,
  isUserActive: PropTypes.bool,
  navigateTo: PropTypes.func.isRequired,
  pathname: PropTypes.string.isRequired,
  t: PropTypes.func.isRequired,
  userRole: PropTypes.string
};

const mapStateToProps = (state) => ({
  candidate: state.users.selectedCandidate,
  isUserActive: state.auth.profile.isUserActive,
  pathname: state.router.location.pathname,
  userRole: state.auth.role
});

const mapDispatchToProps = { clearSelectedCandidate, navigateTo };

export default compose(
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
  withNamespaces()
)(BookingsToolbar);
